import React, { useEffect, useState, useRef, useContext } from "react";
import PdtHeader from "./pdtheader.js";
import Form from 'react-bootstrap/Form';
import AmbSSTUC from "./ambsstuc.js";
import FooterPrice from "./footerprice.js"
import axios from "axios";
import ModelSelectCard from "./modelselectcard.js";
import "./css/common.css";
import Loader from 'react-loader-spinner'
import { Alert } from "react-bootstrap";
import "./css/selectioncard.css";
import { useTranslation } from 'react-i18next';
import { StateAmbContext } from '../../stateContext.js';
import { FaInfoCircle } from 'react-icons/fa';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import BuildCUNew from "./buildcunew.js";
import { fetchMitigationData } from "./mitigationzone.js"
import A2LToggle from "./a2lToggle.js";

export default function BuildUCNew(props) {
    const { settings } = useContext(StateAmbContext);
    const { t, i18n } = useTranslation();
    const [hideBuilder, setBuilder] = useState(false);
    const [state, setState] = useState({ selectionmode: "direct", loader: true, noModels: false, AlertMessage: t('alert_msg.at_this_point') })
    const [error, setError] = useState('');
    const [selectedValue, setSelectedValue] = useState(props.activevalue.ref);
    const [selectedMaterial, setSelectedMaterial] = useState('')
    const [getModelNumber, setGetModelNumber] = useState('')
    const [mitigationzonedata, setMitigationZoneData] = useState([])
    const [height, setHeight] = useState(7.2);
    const [area, setArea] = useState(0);
    const [renderAreaAndHeightInputs, setRenderAreaAndHeightInputs] = useState(false)
    const [shouldFetchMitigation, setShouldFetchMitigation] = useState(true);


    const [selectedRds, setSelectedRds] = useState("")
    const changeView = (view) => {
        setBuilder(view);
    }

    const [prevarea, setPrevArea] = useState('')

    const dataProps = useRef();
    const SelectedModel = props.activevalue.selected_model;
    const controllerRef = useRef();
    const timeoutRef = useRef(null);
    const [a2lisOn, setA2lsOn] = useState(localStorage.getItem('a2lToggle') === "true" ? true : false);
    const [threeModel, setThreeModel] = useState(false);
    const [shouldTriggerMitigation, setShouldTriggerMitigation] = useState(false);
    const requestIdRef = useRef(0);

    useEffect(() => {
        const storedArea = localStorage.getItem('area');
        if (storedArea) {
            setArea(storedArea);
        }
    }, []);

    const a2lToggleHandler = () => {
        setA2lsOn((prevState) => {
            const newValue = !prevState;
            const isRefValid = ['R-455A', 'R-454A', 'R-454C'].includes(props.activevalue.ref);
            if (isRefValid && newValue) {
                localStorage.setItem('a2lToggle', JSON.stringify(true));
            } else {
                localStorage.setItem('a2lToggle', JSON.stringify(newValue));
            }
            return newValue;
        });
    };

    useEffect(() => {
        const storedA2L = localStorage.getItem('a2lToggle');
        if (storedA2L !== null) {
            setA2lsOn(JSON.parse(storedA2L));
        }
    }, []);

    useEffect(async () => {
        if (SelectedModel) {
            setState((prevState) => ({ ...prevState, loader: true }));
            if (controllerRef.current) {
                controllerRef.current.abort();
            }
            const controller = new AbortController();
            controllerRef.current = controller;
            var materialObj = {};
            var modelObj = props.activevalue.models.find(model => {
                if (model.model === SelectedModel) {
                    return model;
                }
            });
            let hold_packages;
            if (['R-455A', 'R-454A', 'R-454C'].includes(props.activevalue.ref) && localStorage.getItem('rds') === "Field Installed") {
                hold_packages = modelObj.option_packages.filter(op => op.code == "B0000").map(op => {
                    return op.code;
                });
            } else {
                hold_packages = modelObj.option_packages.filter(op => op.code !== "B0000").map(op => {
                    return op.code;
                });
            }

            if (hold_packages.length === 0) {
                setState((prevState) => ({ ...prevState, loader: false }));
                return;
            }
            materialObj[SelectedModel] = hold_packages;
            const params = { "accessTokenUrl": settings.service_url, 'PriceURL': settings.service_url, materialModels: materialObj };
            const res = await fetch(settings.service_url_pricing,
                {
                    method: "POST",
                    body: JSON.stringify({ 'params': params }),
                    signal: controllerRef.current?.signal
                }
            ).then(async (pricingres) => {
                const data = await pricingres.json();
                await props.updateNewPrice("UC", data['results']);
                controllerRef.current = null;
                setState((prevState) => ({ ...prevState, loader: false }));
            }).catch(() => {
                setState((prevState) => ({ ...prevState, loader: false }));
            });
            setState((prevState) => ({ ...prevState, loader: false }));

        }
    }, [SelectedModel, localStorage.getItem('rds')]);

    const [error1, setError1] = useState("");

    useEffect(() => {
        setArea(localStorage.getItem('area'))
    }, [localStorage.getItem('area')]);

    useEffect(() => {
        setSelectedRds(localStorage.getItem('rds'))
    }, [localStorage.getItem('rds')]);

    useEffect(() => {
        if (props.tool) {
            props.update("ref", selectedValue);
        }
    }, [props.a2lselect]);

    useEffect(() => {
        if (!shouldFetchMitigation || !shouldTriggerMitigation) return;

        const timer = setTimeout(async () => {
            setRenderAreaAndHeightInputs(true);
            setState((prevState) => ({ ...prevState, loader: true }));

            try {
                await fetchMitigationData({
                    area,
                    selectedValue: props.activevalue.ref,
                    height,
                    getModelNumber,
                    props,
                    setMitigationZoneData,
                    setPrevArea,
                    setState,
                    settings,
                    threeModel
                });
            } catch (error) {
                console.error("Error fetching mitigation data:", error);
            } finally {
                setState((prevState) => ({ ...prevState, loader: false }));
            }

            setShouldTriggerMitigation(false);
        }, 0);

        return () => clearTimeout(timer);
    }, [props.activevalue.ref, shouldTriggerMitigation, shouldFetchMitigation]);
    //}, [height, area, props.activevalue.ref, getModelNumber, props.activevalue.temp, props.activevalue.model_style, props.activevalue.btuh, props.activevalue.amb_temp, props.activevalue.sst, props.activevalue.AWEF, props.activevalue.brand, props.activevalue.count, props.activevalue.voltage, props.activevalue.td, props.activevalue.defrost, props.activevalue.motor]);
    useEffect(() => {
        if (getModelNumber) {
            setShouldTriggerMitigation(true);
        }
    }, [getModelNumber]);

    const handleHeightChange = (e) => {
        const value = e.target.value;
        setHeight(value);
        if (value !== "" && !isNaN(parseFloat(value)) && parseFloat(value) >= 5.0 && parseFloat(value) <= 80) {
            setError1("");
        } else {
            setError1("Height must be between 5.0 and 80.");
        }
        props.update("height", e.target.value);
        fetchMitigationData({
            area,
            selectedValue: props.activevalue.ref,
            height: value,
            getModelNumber,
            props,
            setMitigationZoneData,
            setPrevArea,
            setState,
            settings,
            threeModel
        });
    };

    const handleAreaChange = (e) => {
        const value = e.target.value != null ? e.target.value : 0;
        if (value !== "" && height !== "" && !isNaN(parseFloat(height)) && parseFloat(height) >= 5.0) {
            setArea(value);
            setState({ loader: true });
        } else {
            console.error("Conditions not met for area change");
        }
        localStorage.setItem("area", value);
        props.update("area", value);
        fetchMitigationData({
            area: value,
            selectedValue: props.activevalue.ref,
            height,
            getModelNumber,
            props,
            setMitigationZoneData,
            setPrevArea,
            setState,
            settings,
            threeModel
        });
    };

    useEffect(() => {
        let defaultModel = {
            "model": "Unavailable",
            "label": "",
            "btuh": 23890,
            "price": 0,
            "awef": 7.6,

            "option_packages": [
                { "code": "B0000", "label": "Air Defrost Timer", "price": 0 },
                { "code": "B0200", "label": "Dummy Timer", "price": 0 },
                { "code": "B0300", "label": "Another Timer", "price": 0 },
                { "code": "B0400", "label": "Testing Timer", "price": 0 }

            ],
            "technical_data": [
                { "label": "Capacity", "value": 0 },
                { "label": "MCA", "value": 0 },
                { "label": "MOPD", "value": 0 }
            ]
        }

        let user_input = props.activevalue;
        let a2lLocal = ['R-455A', 'R-454A', 'R-454C'].includes(user_input.ref) ? true : JSON.parse(localStorage.getItem('a2lToggle'));
        let unit_type = (props.tool === "System" ? "uc_system" : "uc")
        let comparator_str = JSON.stringify({
            type: unit_type,
            awef_flag: user_input.AWEF,
            brand: user_input.brand,
            Application: user_input.temp,
            voltage: user_input.voltage,
            ref: user_input.ref,
            defrost: user_input.defrost,
            sst: String(user_input.sst),
            btuh: Number(user_input.btuh),
            count: Number(user_input.count),
            motor: user_input.motor,
            td: (unit_type === "uc_system" ? String(user_input.td) : user_input.td),
            model_style: user_input.model_style,
            area: Number(user_input.area),
            a2l_flag: ['R-455A', 'R-454A', 'R-454C'].includes(user_input.ref)
                ? true : (localStorage.getItem('a2lToggle') === null || localStorage.getItem('a2lToggle') === undefined ? false : JSON.parse(localStorage.getItem('a2lToggle'))),
        });

        dataProps.current = comparator_str;
        if (props.tool === "System") {
            setState({ ...state, loader: true });

        } else {
            setState({ loader: true });
        }

        const selectedOption = ['R-455A', 'R-454A', 'R-454C'].includes(props.activevalue.ref)
            ? (selectedRds === "Factory Installed" ? 'G0000' : 'B0000')
            : user_input.selected_option;
            
        // Increment request ID to track latest request
        requestIdRef.current += 1;
        const currentRequestId = requestIdRef.current;
        
        axios.get(settings.marketing_service_url_1 + `?type=${unit_type}&awef_flag=${user_input.AWEF}&Application=${user_input.temp}&ref=${user_input.ref}&defrost=${user_input.defrost}&voltage=${user_input.voltage}&motor=${user_input.motor}&sst=${user_input.sst}&btuh=${user_input.btuh}&count=${user_input.count}&selected_option=${selectedOption}&brand=${user_input.brand}&td=${user_input.td}&model_style=${user_input.model_style}&a2l_flag=${a2lLocal}`)
            .then(async (response) => {
                // Only process if this is still the latest request
                if (currentRequestId !== requestIdRef.current) {
                    return; // Ignore outdated responses
                }

                setState({ ...state, loader: true });

                if (response.data.lower === null && response.data.recom === null && response.data.upper === null) {
                    setThreeModel(true);
                    setShouldFetchMitigation(false);
                } else {
                    setThreeModel(false);
                    const modelNumbers = [];
                    if (response.data.lower && response.data.lower.model) {
                        modelNumbers.push(response.data.lower.model);
                    }
                    if (response.data.recom && response.data.recom.model) {
                        modelNumbers.push(response.data.recom.model);
                    }
                    if (response.data.upper && response.data.upper.model) {
                        modelNumbers.push(response.data.upper.model);
                    }
                    setGetModelNumber(modelNumbers);
                    setShouldFetchMitigation(true);
                }

                if (true) { // Condition to handle quick changes in user input so that only the latest response is updated
                    let models_arr = [];
                    let no_recom_model = false;
                    if (!(response.data.lower === null || response.data.lower.model === undefined)) {
                        let hold = response.data.lower;
                        hold['key'] = "uc_lower"
                        models_arr.push({ ...defaultModel, ...hold })
                    }
                    if (response.data.recom != null && !(response.data.recom.model === undefined || response.data.recom.model === null)) {

                        let hold = response.data.recom;
                        hold['key'] = "uc_recom"
                        hold['label'] = "RECOMMENDED"
                        models_arr.push({ ...defaultModel, ...hold })
                    } else {
                        no_recom_model = true;
                    }
                    if (response.data.upper != null && !(response.data.upper.model === undefined)) {

                        let hold = response.data.upper;
                        hold['key'] = "uc_upper"
                        models_arr.push({ ...defaultModel, ...hold })
                    }
                    if (models_arr.length === 0) {
                        props.update("models", [defaultModel, defaultModel, defaultModel]);
                        if (props.tool === "System") {
                            props.setUCModels(true);
                        }
                        setState({ noModels: true, AlertMessage: t('alert_msg.unable_find_model'), loader: false })
                    } else if (no_recom_model) {
                        if (props.tool === "System") {
                            props.setUCModels(true);
                        }
                        setState({ noModels: true, loader: false, AlertMessage: (settings.is_hub ? t('alert_msg.cap_out_range_hub') : t('alert_msg.cap_out_range')) })
                        models_arr = [];
                    }
                    else {
                        if (props.tool === "System") {
                            props.setUCModels(false);
                        }
                        props.update("models", models_arr);
                        setState({ ...state, loader: false, noModels: false });
                        var materialObj = {};
                        for (var i = 0; i < models_arr.length; i++) {
                            materialObj[models_arr[i].model] = ['R-455A', 'R-454A', 'R-454C'].includes(props.activevalue.ref) && (selectedRds || props.activevalue.rds) === "Factory Installed" ? ["G0000"] : ["B0000"];
                        };
                        const params = { "accessTokenUrl": settings.service_url, 'PriceURL': settings.service_url, materialModels: materialObj };

                        await fetch(settings.service_url_pricing, {
                            method: "POST",
                            body: JSON.stringify({ 'params': params })
                        }).then(async (pricingres) => {
                            // Check if this is still the latest request
                            if (currentRequestId !== requestIdRef.current) {
                                return; // Ignore outdated responses
                            }
                            const data = await pricingres.json();
                            await props.updateNewPrice("UC", data['results']);
                            setSelectedMaterial(data.results);
                            // const materialKeys = Object.keys(data.results);
                            // setGetModelNumber(materialKeys);
                            setState({ ...state, noModels: false, loader: false });
                        }).catch(() => {
                            setState({ ...state, noModels: true, loader: false });
                        });
                    };
                }



            })

            .catch(err => {
                setState({ loader: false, noModels: true, AlertMessage: t('alert_msg.technical_err') })
            })

    }, [props.activevalue.ref, props.activevalue.temp, props.activevalue.model_style, props.activevalue.btuh, props.activevalue.amb_temp, props.activevalue.sst, props.activevalue.AWEF, props.activevalue.brand, props.activevalue.count, props.activevalue.voltage, props.activevalue.td, props.activevalue.defrost, props.activevalue.motor, props.activevalue.rds, localStorage.getItem('a2lToggle')]);

    let modelList = props.activevalue.models.map((model, index) => {
        return (
            <ModelSelectCard
                unit="uc"
                match={props.match}
                tool={props.tool}
                condn_units_count={props.tool === "System" ? props.condn_units_count : 1}
                selected_option={props.activevalue.selected_option}
                onClick={() => { props.update("selected_model", model.model); }}
                updateaMin={(amin) => { props.update("aMin", amin); }}
                updatezone={(zone) => { props.update("zone", zone); }}
                updateMinAndZone={(aminValue, zoneValue) => {
                    props.update_uc_min_and_zone(aminValue, zoneValue);
                }}
                active={model.model === props.activevalue.selected_model ? "active" : ""}
                key={model.key || index}
                {...model}
                mitigationData={mitigationzonedata}
                mitigationIndex={index}  // 🔥 this is the key change
                a2lselect={props.activevalue.ref}
            />
        );
    });


    let boxarea = (state.loader ? <div className="loader" ><Loader
        type="Puff"
        color="#2D6FB7"
        height={100}
        width={100}
        visible={state.loader}

    /></div> : modelList)

    const handleRdsChange = async (e) => {
        const selectedRds = e.target.value;
        setSelectedRds(selectedRds);
        props.update("rds", selectedRds);
        localStorage.setItem('rds', selectedRds);
    }

    const handleDropdownChange = async (e) => {
        let areaDisabled = localStorage.getItem('areaDisable');
        if (areaDisabled === null || areaDisabled === 'false') {
            localStorage.removeItem('area');
            setArea(0)
        }
        const selectedValue = e.target.value;
        setSelectedValue(selectedValue);
        props.update("ref", selectedValue);
        if (['R-455A', 'R-454A', 'R-454C'].includes(selectedValue)) {
            // localStorage.setItem('a2lToggle', true);
            // setA2lsOn(true);
            const storedRds = localStorage.getItem('rds');
            if (storedRds) {
                setSelectedRds(storedRds);
            } else {
                setSelectedRds('Factory Installed');
                localStorage.setItem('rds', 'Factory Installed')
            }

            const storedArea = localStorage.getItem('area');
            setArea(storedArea || "");

            setError('');
            // await fetchMitigationData({
            //     area: storedArea || "",
            //     selectedValue,
            //     height,
            //     getModelNumber,
            //     props,
            //     setMitigationZoneData,
            //     setPrevArea,
            //     setState,                
            //     settings,
            //     threeModel
            // });
            setRenderAreaAndHeightInputs(true);
        }
        else {
            setA2lsOn(false);
            localStorage.setItem('a2lToggle', false)
            localStorage.removeItem('rds');
        }
    };

    const A2lSection = () => {
        if (["R-455A", "R-454A", "R-454C"].includes(props.activevalue.ref)) {
            return (
                <div className="card-body" style={{ paddingTop: '0px' }}>
                    <div className="dropdown show boldst a2linputs">
                        <div className="row">
                            <div className="col-sm-6">
                                <Form.Group controlId="area">
                                    <Form.Label> Area</Form.Label>
                                    <Form.Control
                                        disabled={localStorage.getItem('areaDisable')}
                                        style={{ maxWidth: "100%" }} as="input"
                                        onChange={handleAreaChange}
                                        value={area}>
                                    </Form.Control>
                                </Form.Group>
                                <p style={{ fontSize: '12px' }}>Note: Enter Area to view the Mitigation Zone details.</p>
                            </div>

                            <div className="col-sm-6">
                                <Form.Group controlId="height">
                                    <Form.Label> Height</Form.Label>
                                    <Form.Control
                                        min="5.0"
                                        max="80"
                                        type="number"
                                        value={height}
                                        onChange={handleHeightChange}
                                        style={{ maxWidth: "100%" }} as="input">
                                    </Form.Control>
                                    {error1 && <small style={{ color: 'red' }}>{error1}</small>}
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };

    let isZoneNA;
    let isZoneVolume;
    let isZoneCirculation;
    let isZoneVentilation;
    let isZoneNotAllowed;
    if (mitigationzonedata && mitigationzonedata.mitigationZoneResponses && mitigationzonedata.mitigationZoneResponses.length > 0) {
        isZoneNA = mitigationzonedata.mitigationZoneResponses.some(item => item.zone === "N/A");
        isZoneVolume = mitigationzonedata.mitigationZoneResponses.some(item => item.zone === "Volume");
        isZoneCirculation = mitigationzonedata.mitigationZoneResponses.some(item => item.zone === "CIRCULATION");
        isZoneVentilation = mitigationzonedata.mitigationZoneResponses.some(item => item.zone === "VENTILATION");
        isZoneNotAllowed = mitigationzonedata.mitigationZoneResponses.some(item => item.zone === "NOT ALLOWED");
    }

    return (
        <>
            {/* {props.tool !== "System" ? <Header /> : <></>} */}
            {props.tool !== "System" ? <><PdtHeader tool={props.tool} unit={"Evaporator"} />
                <AmbSSTUC boxloaded={props.boxloaded} onBuilder={changeView} tool={props.tool} navigate={props.navigate} activevalue={props.activevalue} update={props.update} /></>
                : <></>}
            {props.tool === "Evaporator" ?
                <>
                    <div className="custom_container m-auto">
                        <div className="card-deck card-main card_gr mbtm20">
                            <div className="card card justify-content-center">
                                <div className="disclamer">{(settings.is_hub ? t('common.pdt_disclaimer_hub') : t('common.pdt_disclaimer'))}</div>
                            </div>
                        </div>
                    </div>

                </>
                : <></>}


            <div className={props.tool === "System" ? "row uc_area" : "row"}>
                <div className="custom_container ">
                    {/* <div hidden={hideBuilder} className="card-deck card-main card_gr mbtm20 dropm"> */}
                    <div className="card-deck card-main card_gr mbtm20 dropm media_width">

                        <div className="card card_gr ">
                            <div>
                                <div className="card-body" style={{ paddingBottom: '0px' }}>
                                    <h4 className="card-title type_title" style={{ margin: "0px 0px 22px 0px " }} >{t('unit_names.evap_unit')}</h4>
                                    <div className="dropdown show boldst">
                                        <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="awef">
                                                    <Form.Label>{t('build_Ques.awef')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.AWEF}
                                                        onChange={(e) => { props.update("AWEF", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="Yes">{t('common.Yes')}</option>
                                                        <option value="no">{t('common.No')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>

                                            <div className="col-sm-6" >
                                                <Form.Group controlId="model_style">
                                                    <Form.Label>{t('build_Ques.pdt_family')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.model_style}
                                                        onChange={(e) => { props.update("model_style", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="Low Profile">{t('pdt_family.LOP')}</option>
                                                        <option value="Center Mount">{t('pdt_family.CM')}</option>
                                                        <option value="Low Velocity Center Mount">{t('pdt_family.LVCM')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="count">
                                                    <Form.Label>{props.tool === "System" ? t("build_Ques.sys_uc_units") : t("build_Ques.uc_units")}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.count}
                                                        onChange={(e) => { props.update("count", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="1" >{t('common.numericals.1')}</option>
                                                        <option value="2" >{t('common.numericals.2')}</option>
                                                        <option value="3" >{t('common.numericals.3')}</option>
                                                        <option value="4" >{t('common.numericals.4')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>

                                            {props.tool === "System" ? <div className="col-sm-6" ><Form.Group controlId="defrost">
                                                <Form.Label>{t('build_Ques.defrost')}</Form.Label>
                                                <Form.Control
                                                    value={props.activevalue.defrost}
                                                    onChange={(e) => { props.update("defrost", e.target.value) }}
                                                    style={{ maxWidth: "100%" }} as="select">
                                                    {props.activevalue.temp === "Medium Temp (Cooler)" ? <><option value="Air Defrost" >{t('defrosts.air')}</option><option value="Hot Gas Defrost" >{t('defrosts.gas')}</option>
                                                        <option value="Electric Defrost" >{t('defrosts.electric')}</option></> : <>
                                                        <option value="Electric Defrost" >{t('defrosts.electric')}</option><option value="Hot Gas Defrost" >{t('defrosts.gas')}</option></>}
                                                </Form.Control>
                                            </Form.Group></div> : <div className="col-sm-6" >
                                                <Form.Group controlId="brand">
                                                    <Form.Label>{t('build_Ques.brand')}</Form.Label>
                                                    <Form.Control
                                                        disabled={true}
                                                        value={props.activevalue.brand}
                                                        onChange={(e) => { props.update("brand", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="bohn">{t('brand.Bohn')}</option>
                                                        <option value="chandler">{t('brand.Chandler')}</option>
                                                        <option value="climate_control">{t('brand.Climate Control')}</option>
                                                        <option value="larkin">{t('brand.Larkin')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>}
                                        </div>

                                        {props.tool === "System" ? <></> : <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="ref">
                                                    <Form.Label>{t('build_Ques.ref_type')}
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip id="tooltip-a2l">A2L is Available now</Tooltip>}
                                                        >
                                                            <FaInfoCircle style={{ marginLeft: '8px', cursor: 'pointer', color: '#2d6fb7' }} />
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.ref}
                                                        onChange={handleDropdownChange}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="R-404A">{t('refs.R-404A')}</option>
                                                        <option value="R-407A">{t('refs.R-407A')}</option>
                                                        <option value="R-407C">{t('refs.R-407C')}</option>
                                                        <option value="R-407F">{t('refs.R-407F')}</option>
                                                        <option value="R-448A" selected>{t('refs.R-448A')}</option>
                                                        <option value="R-449A">{t('refs.R-449A')}</option>
                                                        <option value="R-507A">{t('refs.R-507A')}</option>
                                                        <option value="R-455A">{t('refs.R-455A')}</option>
                                                        <option value="R-454A">{t('refs.R-454A')}</option>
                                                        <option value="R-454C">{t('refs.R-454C')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="temp">
                                                    <Form.Label>{t('build_Ques.app_temp')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.temp}
                                                        onChange={(e) => { props.update("temp", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="Medium Temp (Cooler)">{t('app_temp.med')}</option>
                                                        <option value="Low Temp (Freezer)">{t('app_temp.low')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                        </div>
                                        }

                                        <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="motor">
                                                    <Form.Label>{t('build_Ques.motor')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.motor}
                                                        onChange={(e) => { props.update("motor", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="2-Speed EC" >{t('motors.2-Speed EC')}</option>
                                                        <option value="Fixed Speed EC" >{t('motors.Single Speed EC')}</option>
                                                        <option value="PSC Total Enclosed" >{t('motors.PSC Total Enclosed')}</option>
                                                        {/* <option value="Variable Speed EC External Rotor" >{t('motors.Variable Speed EC External Rotor')}</option> */}
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>

                                            <div className="col-sm-6" >
                                                <Form.Group controlId="voltage">
                                                    <Form.Label>{t('build_Ques.voltage')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.voltage}
                                                        onChange={(e) => { props.update("voltage", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="115/1/60" >{t('voltages.115/1/60')}</option>
                                                        <option value="208-230/1/60" >{t('voltages.208-230/1/60')}</option>
                                                        <option value="208-230/3/60" >{t('voltages.208-230/3/60')}</option>
                                                        <option value="460/1/60" >{t('voltages.460/1/60')}</option>
                                                        <option value="220/1/50" >{t('voltages.220/1/50')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row" >
                                            {props.tool === "System" ? <div className="col-sm-6" >
                                                <Form.Group controlId="td">
                                                    <Form.Label>{t('build_Ques.temp_diff')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.td}
                                                        onChange={(e) => { props.update("td", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        {props.activevalue.temp === "Medium Temp (Cooler)" ? <></> : <option value="8">{t('common.temp_deg.8F')}</option>}
                                                        <option value="9">{t('common.temp_deg.9F')}</option>
                                                        <option value="10">{t('common.temp_deg.10F')}</option>
                                                        {props.activevalue.temp === "Medium Temp (Cooler)" ? <option value="11">{t('common.temp_deg.11F')}</option> : <></>}
                                                    </Form.Control>
                                                </Form.Group>
                                            </div> : <></>}

                                            {props.tool === "Evaporator" && (
                                                <div className="col-sm-6">
                                                    <Form.Group controlId="defrost">
                                                        <Form.Label>{t('build_Ques.defrost')}</Form.Label>
                                                        <Form.Control
                                                            value={props.activevalue.defrost}
                                                            onChange={(e) => { props.update("defrost", e.target.value) }}
                                                            style={{ maxWidth: "100%" }}
                                                            as="select">
                                                            {props.activevalue.temp === "Medium Temp (Cooler)" ? (
                                                                <>
                                                                    <option value="Air Defrost">{t('defrosts.air')}</option>
                                                                    <option value="Hot Gas Defrost">{t('defrosts.gas')}</option>
                                                                    <option value="Electric Defrost">{t('defrosts.electric')}</option>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <option value="Electric Defrost">{t('defrosts.electric')}</option>
                                                                    <option value="Hot Gas Defrost">{t('defrosts.gas')}</option>
                                                                </>
                                                            )}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                            )}

                                            {(props.tool === "System" || props.tool === "Evaporator") &&
                                                ["R-455A", "R-454A", "R-454C"].includes(props.activevalue.ref) && (
                                                    <div className="col-sm-6">
                                                        <Form.Group controlId="rds">
                                                            <Form.Label>RDS</Form.Label>
                                                            <Form.Control
                                                                value={selectedRds}
                                                                onChange={handleRdsChange}
                                                                style={{ maxWidth: "100%" }} as="select">
                                                                <option value="Factory Installed">{t('rds.factory')}</option>
                                                                <option value="Field Installed">{t('rds.field')}</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>
                                                )}

                                            {!["R-455A", "R-454A", "R-454C"].includes(props.activevalue.ref) && props.tool === "Evaporator" && (
                                                <div className="col-sm-6">
                                                    <A2LToggle a2lValue={a2lisOn} onToggle={a2lToggleHandler} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {renderAreaAndHeightInputs && A2lSection()}
                        </div>

                        <div style={{ backgroundColor: "#E6E7E8" }} className={props.tool === "System" ? "card uc_area_models mtmd10" : "card memargin mtmd10"}>
                            <div>
                                <div className="card-body">
                                    <h4 className="card-title type_title" style={{ margin: "0px 0px 22px 0px " }} >{t('model_select.uc_title')}</h4>
                                    <div className="dropdown show boldst ">
                                        {(props.tool === "System" ? (props.CUnoModels || props.UCnoModels) : (state.noModels)) ? <Alert variant="danger" dismissible>
                                            <Alert.Heading>{t('common.sorry')}</Alert.Heading>
                                            <p>
                                                {/* {state.AlertMessage} */}
                                                {t('alert_msg.unable_find_model')}

                                            </p>
                                        </Alert> :
                                            <>
                                                {boxarea}
                                                <div className="pt4">{t('common.preselect_opt')}</div>
                                                <div className="zone_verbiage">
                                                    {(["R-455A", "R-454A", "R-454C"].includes(props.activevalue.ref) && isZoneNA ? (
                                                        <p>Insufficient Data - Please enter area and height in the previous page to view mitigation zone.</p>
                                                    ) : isZoneVolume ? (
                                                        <p>Volume - Requires Safety Shutoff Valve activation. No additional mitigation action required.</p>
                                                    ) : isZoneCirculation ? (
                                                        <p>CIRCULATION - Requires Safety Shutoff Valve activation and turns on Unit Cooler fans to circulate the air.</p>
                                                    ) : isZoneVentilation ? (
                                                        <p>VENTILATION - Requires Safety Shutoff Valve activation and turns on exhaust fans to ventilate refrigerated space.</p>
                                                    ) : isZoneNotAllowed ? (
                                                        <p>NOT ALLOWED - Equipment is not allowed to be installed if Equipment Amin (Room Minimum Area) is greater than the room area where the equipment is being installed.</p>
                                                    ) : (
                                                        <></>
                                                    ))}
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div >
                {props.tool === "System" ? <></> : <FooterPrice match={props.match} noModels={state.noModels} tool={props.tool} navigate={props.navigate} />}
            </div>
        </>
    )
}